export default __webpack_public_path__ + "layout.theme.styleLiquid.scss.liquid";